export class Paiement {
  modePaiement: string = 'Prelevement';
  fractionnement: number = 0;
  datePrelevement: number = 0;
  civiliteDebiteur: string = '';
  nomDebiteur: string = '';
  prenomDebiteur: string = '';
  adresseDebiteur: string = '';
  adresseComplementDebiteur: string = '';
  codePostalDebiteur: string = '';
  ville: string = '';
  nomEtablissement: string = '';
  iban: string = '';
  bic: string = '';
  telaRappeler: string = '';
  eMailRecontacte: string = '';

  constructor(
    modePaiement: string,
    fractionnement: number,
    datePrelevement: number,
    civiliteDebiteur: string,
    nomDebiteur: string,
    prenomDebiteur: string,
    adresseDebiteur: string,
    adresseComplementDebiteur: string,
    codePostalDebiteur: string,
    ville: string,
    nomEtablissement: string,
    iban: string,
    bic: string,
    telaRappeler: string,
    eMailRecontacte: string,
  ) {
    this.modePaiement = modePaiement;
    this.fractionnement = fractionnement;
    this.datePrelevement = datePrelevement;
    this.civiliteDebiteur = civiliteDebiteur;
    this.nomDebiteur = nomDebiteur;
    this.prenomDebiteur = prenomDebiteur;
    this.adresseDebiteur = adresseDebiteur;
    this.adresseComplementDebiteur = adresseComplementDebiteur;
    this.codePostalDebiteur = codePostalDebiteur;
    this.ville = ville;
    this.nomEtablissement = nomEtablissement;
    this.iban = iban;
    this.bic = bic;
    this.telaRappeler = telaRappeler;
    this.eMailRecontacte = eMailRecontacte;
  }
}
